import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
    BingoConfig,
    BingoConfigProviderService,
    DesignSystemEnablerService,
    FeaturesClientConfig,
    ScheduleService,
} from '@frontend/bingo/frontend-lib/core';
import { DeviceService, LoadingIndicatorService, SessionStoreService, UserLoginEvent, UserService } from '@frontend/vanilla/core';
import { SwiperComponent } from '@frontend/vanilla/shared/swiper';
import { filter } from 'rxjs/operators';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { LoginService } from '../../services/login-Service';
import { SessionPackageService } from '../../services/session-package.service';
import { PackageItemComponent } from './package-item/package-item.component';
import { PackagesFilterComponent } from './packages-filter/packages-filter.component';

@Component({
    selector: 'bg-session-bingo',
    templateUrl: './session-bingo.component.html',
    imports: [CommonModule, PackagesFilterComponent, PackageItemComponent],
})
export class SessionBingoComponent implements OnInit, OnDestroy {
    //public config: NguCarouselConfig;
    sessionData: any;
    time: any;
    roomTitle: string;
    weeklySchedule: any[7][] = [[{}], [{}], [{}], [{}], [{}], [{}], [{}]];
    week: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    days: string[] = [];
    day: number[] = [];
    timeSortedSessionList: any = [];
    morningHours: number;
    morningMinutes: number;
    afternoonHours: number;
    afternoonMinutes: number;
    eveningHours: number;
    isLegacy: boolean = false;
    eveningMinutes: number;
    twilightHours: number;
    twilightMinutes: number;
    displaynosessionMessage: boolean;
    displaynosession: boolean;
    sessionsLoading: boolean = true;
    content: any = [];
    packageContent: any = [];
    headers: any = [];
    fromTimeHours: number;
    fromTimeMinutes: number;
    toTimeHours: number;
    toTimeMinutes: number;
    bingoContent: any;
    enableTodaySection: boolean;
    activeTimeArray: number[] = [1, 1, 1, 1];
    isInGameClient: boolean = false;
    headerTimesArr: any = [];
    AvailableDays: any = [];
    bingoMultiline = false;
    src: any;
    clientConfig: any;
    sessionId: any;
    sessionIdMoreInfo: any;
    @ViewChild('sessionListCarousel') mycarousel: SwiperComponent;
    featuresConfig: FeaturesClientConfig;
    bingoConfig: BingoConfig;
    _selectedDay: number = -1;
    showDaysListDropdown: boolean = false;
    packageFilterItems: any[] = [];
    selectedFilterItem: any;
    _loadingIndicator: any;
    sessionPackagesAvailable = false;
    @ViewChildren('sessions') private sessions: QueryList<PackageItemComponent>;
    swiperOptionsSessionBingo: SwiperOptions = {
        modules: [Navigation, Pagination, Autoplay],
        loop: false,
        speed: 500,
        autoHeight: true,
        spaceBetween: 1,
        direction: 'horizontal',
        // slidesPerView: 0,
        centeredSlides: false,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        //     pauseOnMouseEnter: true,
        //     waitForTransition: false
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: false,
        pagination: false,
        slidesPerGroup: 1,
        keyboard: true,
        scrollbar: false,
        preventClicks: false,
        preventClicksPropagation: false,
    };
    @ViewChild('daysLiterFilterDropdown') daysLiterFilterDropdown: ElementRef;

    constructor(
        private sessionService: SessionPackageService,
        private session: SessionStoreService,
        private scheduleService: ScheduleService,
        private designSystemEnablerService: DesignSystemEnablerService,
        public loginService: LoginService,
        private deviceService: DeviceService,
        private activeroute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private configProviderService: BingoConfigProviderService,
        private user: UserService,
        private loadingIndicatorService: LoadingIndicatorService,
    ) {
        this.featuresConfig = this.configProviderService.provideFeaturesConfig();
        this.bingoConfig = this.configProviderService.provideBingoConfig();
    }

    @HostListener('document:click', ['$event'])
    onClick(ev: MouseEvent) {
        if (this.daysLiterFilterDropdown && this.showDaysListDropdown == true) {
            const clickInside = this.daysLiterFilterDropdown?.nativeElement.contains(ev.target);
            if (!clickInside) {
                this.showDaysListDropdown = false;
            }
        }
    }

    ngOnInit() {
        this.isLegacy = this.designSystemEnablerService.isEnabled();
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        }
        if (this.featuresConfig.packagesfilterMap) {
            this.packageFilterItems = Object.values(this.featuresConfig.packagesfilterMap);
        }
        this.bingoMultiline = this.bingoConfig.bingoMultiline;
        if (this.activeroute.snapshot.queryParamMap.get('ingame=true')) {
            this.isInGameClient = true;
        }
        // this.setSitecoreContent();
        this.content = this.clientConfig?.sessionGlobalMessages;
        this.packageContent = this.clientConfig?.packageGlobalMessages;
        this.time = 60;
        this.setDays();
        this.getSessionData();
        //this.checkForPurchasedPackageOld();
        // this.checkForPurchasedPackage();
        if (this.deviceService.isTouch || (window.innerWidth <= 1365 && window.innerWidth >= 768)) {
            this.swiperOptionsSessionBingo.navigation = false;
        }
        if (this.deviceService.isTablet || (window.innerWidth <= 1023 && window.innerWidth >= 768)) {
            this.swiperOptionsSessionBingo.slidesPerView = 2;
        } else if (window.innerWidth <= 1365 && window.innerWidth >= 1024) {
            this.swiperOptionsSessionBingo.slidesPerView = 3;
        } else if (this.deviceService.isMobile) {
            this.swiperOptionsSessionBingo.slidesPerView = 1;
        } else {
            this.swiperOptionsSessionBingo.slidesPerView = 4;
        }
        //call getSessionData when the user logs in session bingo page
        this.user.events.pipe(filter((e) => e instanceof UserLoginEvent)).subscribe(() => {
            this.displaynosession = true;
            this.getSessionData();
        });
    }
    constructHeaders() {
        let splitTimeNumber = this.splitTime();
        splitTimeNumber = this.getActiveSessionBasedOnSessionAvailability(splitTimeNumber);
        this.headers = [
            {
                title: this.content?.Morning,
                startHours: this.morningHours,
                startMinutes: this.morningMinutes,
                endHours: this.afternoonHours,
                endMinutes: this.afternoonMinutes,
                isActive: splitTimeNumber == 0,
                splitNumber: 0,
                icon: 'theme-session-morning',
                isDisabled: this.activeTimeArray[0] == 0,
            },
            {
                title: this.content?.Afternoon,
                startHours: this.afternoonHours,
                startMinutes: this.afternoonMinutes,
                endHours: this.eveningHours,
                endMinutes: this.eveningMinutes,
                isActive: splitTimeNumber == 1,
                splitNumber: 1,
                icon: 'theme-session-afternoon',
                isDisabled: this.activeTimeArray[1] == 0,
            },
            {
                title: this.content?.Evening,
                startHours: this.eveningHours,
                startMinutes: this.eveningMinutes,
                endHours: this.twilightHours,
                endMinutes: this.twilightMinutes,
                isActive: splitTimeNumber == 2,
                splitNumber: 2,
                icon: 'theme-session-evening',
                isDisabled: this.activeTimeArray[2] == 0,
            },
            {
                title: this.content?.Twilight,
                startHours: this.twilightHours,

                startMinutes: this.twilightMinutes,
                endHours: this.morningHours,
                endMinutes: this.morningMinutes,
                isActive: splitTimeNumber == 3,
                splitNumber: 3,
                icon: 'theme-session-twilight',
                isDisabled: this.activeTimeArray[3] == 0,
            },
        ];
        this.sortandassignSessionCategories(splitTimeNumber);
    }
    getActiveSessionBasedOnSessionAvailability(splitTimeNumber: any) {
        if (this.activeTimeArray && this.activeTimeArray[splitTimeNumber] != 1) {
            let activeSplitNumber = splitTimeNumber;
            for (let i = splitTimeNumber; i < this.activeTimeArray.length; i++) {
                if (this.activeTimeArray[i] == 1) {
                    activeSplitNumber = i;
                    break;
                }
            }
            if (activeSplitNumber == splitTimeNumber) {
                for (let i = 0; i < splitTimeNumber; i++) {
                    if (this.activeTimeArray[i] == 1) {
                        activeSplitNumber = i;
                        break;
                    }
                }
            }
            splitTimeNumber = activeSplitNumber;
        }
        return splitTimeNumber;
    }
    // checkForPurchasedPackage() {
    //     this.sessionService.isPurchaseObsevable.subscribe((response: any) => {
    //         if (response) {
    //             this.sessionItems.forEach((element: any) => {
    //                 if (element.sessionId == response.Id) {
    //                     if (response.isPurchase) element.staus_of_package = 'purchase';
    //                     else element.staus_of_package = 'purchased';
    //                     // this.getSessionData();
    //                 }
    //             });
    //         }
    //     });
    // }
    setSitecoreContent(sitecoreData: any) {
        //this.sessionService.getSitecoreContent('session_bingo').subscribe((response: any) => {
        if (sitecoreData) {
            this.bingoContent = sitecoreData.data.fields;
            this.assignTimings();

            this.constructHeaders();
            if (this.featuresConfig.disableTimeSessions) {
                this.activeTimeArray = [0, 0, 0, 0];
                this.checkActiveSessions();
            }
        }
        //});
    }
    setDays() {
        const dayNow = new Date().getDay();
        this.days.push('Today');
        this.day.push(dayNow);
        for (let i = dayNow + 1; i < 7; i++) {
            this.days.push(this.week[i]);
            this.day.push(i);
        }
        for (let i = 0; i < dayNow; i++) {
            this.days.push(this.week[i]);
            this.day.push(i);
        }
    }
    getSessionListData(gameData: any) {
        this.sessionService.getSessionList('session_bingo', gameData).subscribe(
            (response: any) => {
                this.sessionsLoading = false;
                if (response?.bingoPackageList) {
                    if (response.bingoPackageList.result.package_list?.package_list) {
                        let sessionList = response.bingoPackageList.result.package_list.package_list.packages;
                        this.sessionService.packageIdOrderedList = response.packageIdOrderedList || [];
                        const sessionIds = Object.keys(sessionList);
                        let sessionItems = Object.values(sessionList);
                        for (let val = 0; val < sessionItems.length; val++) {
                            this.sessionService.onPackageInfoFromSessionList(sessionIds[val], sessionItems[val]);
                        }
                        this.sessionPackagesAvailable = true;
                        if (this.loginService.sessionBingoforcedData?.id && this.sessions && this.sessions.length) {
                            const packageItem: any = this.sessions.find((item) => item.id == this.loginService.sessionBingoforcedData.id);
                            if (this.loginService.sessionBingoforcedData.triggerType == 'moreInfo' && packageItem) {
                                packageItem?.moreInfoClicked();
                            } else if (this.loginService.sessionBingoforcedData.triggerType == 'buyNow' && packageItem) {
                                packageItem?.buyNowClicked();
                            }
                        }
                    } else {
                        this.sessionPackagesAvailable = false;
                    }
                }
                if (response && response.sitecoreData) {
                    this.setSitecoreContent(response.sitecoreData);
                }
                this._loadingIndicator.done();
            },
            () => {
                this.sessionsLoading = false;
                this.sessionPackagesAvailable = false;
                this._loadingIndicator.done();
            },
        );
    }

    getSessionData() {
        const gameData: any = this.session.get('ScheduleFeed');
        this._loadingIndicator = this.loadingIndicatorService.start();
        if (gameData) {
            this.getSessionListData(gameData);
        } else {
            this.scheduleService.getGameData((response: any) => {
                if (response) {
                    this.getSessionListData(response);
                }
            });
        }
    }

    assignTimings() {
        //appen time from sitecore here
        this.morningHours = new Date(this.bingoContent.moriningTime).getUTCHours();
        this.morningMinutes = new Date(this.bingoContent.moriningTime).getUTCMinutes();

        this.afternoonHours = new Date(this.bingoContent.noonTIme).getUTCHours();
        this.afternoonMinutes = new Date(this.bingoContent.noonTIme).getUTCMinutes();

        this.eveningHours = new Date(this.bingoContent.eveningTime).getUTCHours();
        this.eveningMinutes = new Date(this.bingoContent.eveningTime).getUTCMinutes();

        this.twilightHours = new Date(this.bingoContent.twilightTime).getUTCHours();
        this.twilightMinutes = new Date(this.bingoContent.twilightTime).getUTCMinutes();

        this.morningHours = parseInt(String(this.morningHours).padStart(2, '0'));
    }

    splitTime(time: number = 0): number {
        if (!time) {
            const hours = new Date().getHours();
            const minutes = new Date().getMinutes();
            if (this.isTimeInGivenRange(hours, minutes, this.morningHours, this.morningMinutes, this.afternoonHours, this.afternoonMinutes)) {
                time = 0;
            } else if (this.isTimeInGivenRange(hours, minutes, this.afternoonHours, this.afternoonMinutes, this.eveningHours, this.eveningMinutes)) {
                time = 1;
            } else if (this.isTimeInGivenRange(hours, minutes, this.eveningHours, this.eveningMinutes, this.twilightHours, this.twilightMinutes)) {
                time = 2;
            } else if (this.isTimeInGivenRange(hours, minutes, this.twilightHours, this.twilightMinutes, this.morningHours, this.morningMinutes)) {
                time = 3;
            }
        }
        return time;
    }
    checkActiveSessions() {
        let sessionItems: any[] = [];
        if (this.sessionService.packageInfo) sessionItems = Object.values(this.sessionService.packageInfo);
        if (sessionItems && sessionItems.length > 0) {
            sessionItems.forEach((bgRoom: any) => {
                if (this.activeTimeArray[0] == 0) {
                    this.sortSessionCategory(0);
                    if (this.isTimeInGivenRangeNew2(bgRoom.start_time, bgRoom.end_time, 0)) {
                        this.activeTimeArray[0] = 1;
                    }
                }
                if (this.activeTimeArray[1] == 0) {
                    this.sortSessionCategory(1);
                    if (this.isTimeInGivenRangeNew2(bgRoom.start_time, bgRoom.end_time, 1)) {
                        this.activeTimeArray[1] = 1;
                    }
                }
                if (this.activeTimeArray[2] == 0) {
                    this.sortSessionCategory(2);
                    if (this.isTimeInGivenRangeNew2(bgRoom.start_time, bgRoom.end_time, 2)) {
                        this.activeTimeArray[2] = 1;
                    }
                }
                if (this.activeTimeArray[3] == 0) {
                    this.sortSessionCategory(3);
                    if (this.isTimeInGivenRangeNew2(bgRoom.start_time, bgRoom.end_time, 3)) {
                        this.activeTimeArray[3] = 1;
                    }
                }
            });
        }
        this.constructHeaders();
        this.setHeaderTimes();
    }
    setHeaderTimes() {
        const morningTime = new Date().setHours(this.morningHours, this.morningMinutes, 0, 0) / 1000;
        const afternoonTime = new Date().setHours(this.afternoonHours, this.afternoonMinutes, 0, 0) / 1000;
        const eveningTime = new Date().setHours(this.eveningHours, this.eveningMinutes, 0, 0) / 1000;
        const twilightTime = new Date().setHours(this.twilightHours, this.twilightMinutes, 0, 0) / 1000;
        for (let i = 0; i < 7; i++) {
            const dayTime: any = [morningTime + i * 86400, afternoonTime + i * 86400, eveningTime + i * 86400, twilightTime + i * 86400];
            this.headerTimesArr.push(dayTime);
        }
        // console.log(this.headerTimesArr);
    }
    sortandassignSessionCategories(time: number) {
        this.sortSessionCategory(time);
        //this.getNewTimeSortedRooms();
        this.getNewTimeSortedRooms2(time);
    }
    sortSessionCategory(time: number) {
        this.fromTimeHours = this.headers[time].startHours;
        this.fromTimeMinutes = this.headers[time].startMinutes;
        this.toTimeHours = this.headers[time].endHours;
        this.toTimeMinutes = this.headers[time].endMinutes;
        //console.log(this.headers);
    }
    selectSession(splitIndex: number) {
        const activeHeader = this.headers.findIndex((e: any) => e.isActive == true);
        if (this.activeTimeArray[splitIndex] == 1 && activeHeader != splitIndex) {
            this.displaynosession = true;
            if (this.mycarousel) {
                this.mycarousel.swiper.update();
            }
            this.headers.forEach((header: any) => {
                if (header.splitNumber == splitIndex) {
                    this.timeZoneTracking(header);
                    header.isActive = true;
                } else {
                    header.isActive = false;
                }
            });
            this.sortandassignSessionCategories(splitIndex);
        }
    }
    isTimeInGivenRangeNew2(sessionStartTime: any, sessionEndTime: any, headerActiveIndex: any) {
        this.headerTimesArr.length = 0;
        this.setHeaderTimes();
        const currentTime = new Date().getTime() / 1000;
        let toTime = this.headerTimesArr[0][headerActiveIndex + 1 > this.headerTimesArr[0].length - 1 ? 0 : headerActiveIndex + 1];
        if (headerActiveIndex + 1 > this.headerTimesArr[0].length - 1) {
            toTime = this.headerTimesArr[1][0];
        }
        if (currentTime <= toTime) {
            return this.gameAvailableInSession(sessionStartTime, sessionEndTime, headerActiveIndex, false);
        }
        this.enableTodaySection = false;
        const endDay = new Date(sessionEndTime * 1000).getDay();
        const dayNow = new Date().getDay();
        let days = this.gameAvailableInSession(sessionStartTime, sessionEndTime, headerActiveIndex, true);
        days = days.filter((e: any) => {
            return e != 0;
        });
        if (endDay > dayNow && days.length > 0) return true;
        return false;
    }
    gameAvailableInSession(sessionStartTime: any, sessionEndTime: any, headerActiveIndex: any, flag: any) {
        for (let i = 0; i < this.headerTimesArr.length; i++) {
            let gameAvailable = false;
            const fromTime = this.headerTimesArr[i][headerActiveIndex];
            let toTime = this.headerTimesArr[i][headerActiveIndex + 1 > this.headerTimesArr[0].length - 1 ? 0 : headerActiveIndex + 1];
            if (headerActiveIndex + 1 > this.headerTimesArr[0].length - 1) {
                if (i + 1 <= this.headerTimesArr.length - 1) {
                    toTime = this.headerTimesArr[i + 1] ? this.headerTimesArr[i + 1][0] : toTime;
                } else {
                    toTime = this.headerTimesArr[i][0] + 86400;
                }
            }
            if ((fromTime <= sessionStartTime && toTime >= sessionStartTime) || (fromTime <= sessionEndTime && toTime >= sessionEndTime)) {
                gameAvailable = true;
            } else if ((sessionStartTime <= fromTime && sessionEndTime >= fromTime) || (sessionStartTime <= toTime && sessionEndTime >= toTime)) {
                gameAvailable = true;
            }
            if (gameAvailable) {
                if (flag) {
                    this.AvailableDays.push(i);
                } else {
                    this.enableTodaySection = true;
                    return true;
                }
            }
        }
        return flag ? this.AvailableDays : false;
    }
    getNewTimeSortedRooms2(time: any) {
        let sessionItems: any[] = [];
        if (this.sessionService.packageInfo) sessionItems = this.sessionItemsList;
        if (sessionItems && sessionItems.length > 0) {
            const sessionIds: string[] = [];
            this.timeSortedSessionList = [];
            sessionItems.forEach((bgRoom: any) => {
                sessionIds.push(bgRoom.sessionId);
                if (this.isTimeInGivenRangeNew2(bgRoom.start_time, bgRoom.end_time, time)) {
                    this.timeSortedSessionList.push(bgRoom);
                }
            });
            this.sessionService.packageTracking('navigation', 'top navigation', sessionIds.join(','), 'not Aplicable', 'session_bingo');
        }
        this.splitDays(this.timeSortedSessionList, time);
    }
    timeZoneTracking(selectedTime: any) {
        const time_zone = selectedTime.startHours + ':' + selectedTime.startMinutes + '-' + selectedTime.endHours + ':' + selectedTime.endMinutes;
        const time_period = selectedTime.title;
        this.sessionService.packageTracking('Bingo', 'session_bingo', 'not applicable', time_zone, time_period);
    }

    isTodaySectionEnabled(row: number) {
        if (row == 0) {
            if (this.enableTodaySection) return true;
            return false;
        } else {
            return true;
        }
    }

    isTimeInGivenRange(hours: number, minutes: number, fromTimeHours: number, fromTimeMinutes: number, toTimeHours: number, toTimeMinutes: number) {
        if (fromTimeHours < toTimeHours) {
            if (
                (hours > fromTimeHours || (hours === fromTimeHours && minutes > fromTimeMinutes)) &&
                (toTimeHours > hours || (toTimeHours === hours && toTimeMinutes > minutes))
            ) {
                return true;
            }
        } else {
            if (
                ((hours > fromTimeHours || (hours === fromTimeHours && minutes > fromTimeMinutes)) && hours <= 23) ||
                ((hours < toTimeHours || (toTimeHours === hours && toTimeMinutes > minutes)) && hours >= 0)
            ) {
                return true;
            }
        }
        return false;
    }

    splitDays(list: any, headerActiveIndex: any) {
        this.weeklySchedule = [[{}], [{}], [{}], [{}], [{}], [{}], [{}]];
        if (list.length > 0) {
            list.forEach((item: any) => {
                this.AvailableDays.length = 0;
                const currentTime = new Date().getTime() / 1000;
                let toTime = this.headerTimesArr[0][headerActiveIndex + 1 > this.headerTimesArr[0].length - 1 ? 0 : headerActiveIndex + 1];
                if (headerActiveIndex + 1 > this.headerTimesArr[0].length - 1) {
                    toTime = this.headerTimesArr[1][0];
                }
                const days = this.gameAvailableInSession(item.start_time, item.end_time, headerActiveIndex, true);
                for (let i = 0; i < days.length; i++) {
                    if (days[i] == 0) {
                        if (currentTime <= toTime) this.weeklySchedule[days[i]].push(item);
                    } else {
                        this.weeklySchedule[days[i]].push(item);
                    }
                }
            });
        }
        // if (list.length > 0) {
        //   list = list.sort((a: any, b: any) => {
        //     return a["end_time"] - b["end_time"];
        //   });
        //   let currentTime = Math.ceil((new Date().getTime() / 1000))
        //   let remainingTime = Math.ceil(list[0].end_time - currentTime) * 1000
        //   setTimeout(() => {
        //     this.getSessionData();
        //   }, remainingTime)
        // }
        for (let i = 0; i < 7; i++) {
            this.weeklySchedule[i].splice(0, 1);
        }
        // let sortedWeeklySchedule: any[7][] = [];
        // for (let i = 0; i < 7; i++) {
        //   sortedWeeklySchedule[i] = this.weeklySchedule[this.day[i]];
        // }
        // this.weeklySchedule = sortedWeeklySchedule;
        this.cdr.detectChanges();
        this.displaynosessionMessage = false;
        this.weeklySchedule.forEach((element: any) => {
            if (element && element.length > 0) {
                this.displaynosession = false;
                this.displaynosessionMessage = true;
                element = this.sessionService.sortPackages(element);
            }
        });
    }

    get firstAvailableDay() {
        let sessionItems: any[] = [];
        if (this.sessionService.packageInfo) sessionItems = Object.values(this.sessionService.packageInfo);
        if (sessionItems && sessionItems.length > 0) {
            for (let i = 0; i < this.days.length; i++) {
                if (i == 0) {
                    if (this.enableTodaySection && this.weeklySchedule[0].length > 0) {
                        return i;
                    }
                } else if (this.weeklySchedule[i].length > 0) {
                    return i;
                }
            }
        }
        return -1;
    }

    get selectedDay() {
        if (this._selectedDay > 0 && this.weeklySchedule[this._selectedDay].length > 0) {
            return this._selectedDay;
        }
        return this.firstAvailableDay;
    }

    toggleDayListDropdown() {
        if (this.selectedDay > -1) {
            this.showDaysListDropdown = !this.showDaysListDropdown;
        } else {
            this.showDaysListDropdown = false;
        }
    }

    onDaysFilterSelect(val: any) {
        this._selectedDay = val;
    }

    get sessionItemsList() {
        let sessionItems: any[] = [];
        let packageKeys = this.sessionService.packageInfo;
        for (let key in packageKeys) {
            let item = this.sessionService.packageInfo[key];
            if (item && !item.hideItem) {
                item.sort_weight_value = item.sort_weight_value || 1000;
                sessionItems.push(item);
            }
        }
        const sortedItems = this.sessionService.sortPackages(sessionItems);
        return sortedItems;
    }

    filterOptionClicked(filterItem: any) {
        if (filterItem == this.selectedFilterItem) {
            return;
        } else {
            this.selectedFilterItem = filterItem;
            this.sessionService.filterPackages(filterItem);
        }
    }

    ngOnDestroy() {
        this.sessionService.clearPackageInfo();
    }
}
